import React from 'react';
import {useParams} from 'react-router-dom';
import {QueueListIcon} from '@heroicons/react/24/outline';
import {useMe} from 'hooks';

import BillingHeader from './Billing.Header';

interface IBillingPlansProps {}

const BillingPlans = ({}: IBillingPlansProps) => {
  const params = useParams();
  const workspace = params.workspace ?? '';

  const me = useMe();
  const plan = me?.plan;
  const text = plan?.name ?? '';

  return (
    <BillingHeader icon={QueueListIcon} name="Subscription Plan" text={text} buttonText="Manage plan" buttonUrl={`/${workspace}/billing/plans`} />
  );
};

export default React.memo(BillingPlans);
